import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/xt-report/";

//24小时平均xt持有
export function getAssetAvgPosition(config) {
  return XtAxios.get(URL + `asset/avg-position`, config);
}

//普通用户vip list
export function getNormalVipList(config) {
  return XtAxios.get(URL + `public/vip/list`, config);
}

//资产趋势
export function getAssetTrend(config) {
  return XtAxios.get(URL + `asset/trend`, config);
}
